import { render, staticRenderFns } from "./SdButton.html?vue&type=template&id=576a2d80&external"
import script from "./SdButton.ts?vue&type=script&lang=ts&external"
export * from "./SdButton.ts?vue&type=script&lang=ts&external"
import style0 from "./SdButton.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports